import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSizes } from '../../../redux/slices/SizeSlice';
import { userID } from '../../../utils/helper';
import { Link } from 'react-router-dom';

export default function SizeList() {
	const [activeTab, setActiveTab] = useState('teeshirt');
	const dispatch = useDispatch();
	const userId = userID();
	const sizes = useSelector(state => state.sizeDimension.sizes);

	useEffect(() => {
		dispatch(fetchSizes(userId));
	}, [dispatch, userId]);

	const tabs = [
		{ id: 'teeshirt', label: 'Teeshirt' },
		{ id: 'halfSleeve', label: 'Half Sleeve' },
		{ id: 'fullSleeve', label: 'Full Sleeve' },
	];

	const teeshirtSizes = sizes.map(item => ({
		age: item.age,
		number: item.label,
		measure: `${item.width} X ${item.height} in`
	}));

	const halfSleeveSizes = sizes.map(item => ({
		age: item.age,
		number: item.label,
		measure: `${item.halfSleeveWidth} X ${item.halfSleeveHeight} in`
	}));

	const fullSleeveSizes = sizes.map(item => ({
		age: item.age,
		number: item.label,
		measure: `${item.fullSleeveWidth} X ${item.fullSleeveHeight} in`
	}));

	return (
		<div className='artboard--main__variations--size-samples'>
			<h3>Size samples</h3>

			{/* Tabs */}
			<div className='artboard--main__variations--size-samples__tabs'>
				{tabs.map((tab) => (
					<div
						key={tab.id}
						className={`artboard--main__variations--size-samples__tabs--item ${
							activeTab === tab.id ? 'active' : ''
						}`}
						onClick={() => setActiveTab(tab.id)}>
						{tab.label}
					</div>
				))}
			</div>

			{/* Teeshirt Content */}
			{activeTab === 'teeshirt' && (
				<div className='artboard--main__variations--size-samples__tabs--content active'
        style={{cursor: "pointer"}}>
					{teeshirtSizes.map((item, index) => (
						<div
							key={index}
							className='artboard--main__variations--size-samples__tabs--content--list'>
							<div className='size-age'>{item.age}</div>
							<div className='size-number'>{item.number}</div>
							<div className='size-measure'>{item.measure}</div>
						</div>
					))}
					<div className='block-center'>
						<Link to='/sizes' className='button-common button--light'>
							<img src='/assets/images/size-setting.svg' alt='' /> Change Sizes
						</Link>
					</div>
				</div>
			)}

			{/* Half Sleeve Content */}
			{activeTab === 'halfSleeve' && (
				<div className='artboard--main__variations--size-samples__tabs--content active' 
        style={{cursor: "pointer"}}>
					{halfSleeveSizes.map((item, index) => (
						<div
							key={index}
							className='artboard--main__variations--size-samples__tabs--content--list'>
							<div className='size-age'>{item.age}</div>
							<div className='size-number'>{item.number}</div>
							<div className='size-measure'>{item.measure}</div>
						</div>
					))}
					<div className='block-center'>
						<Link to='/sizes' className='button-common button--light'>
							<img src='/assets/images/size-setting.svg' alt='' /> Change Sizes
						</Link>
					</div>
				</div>
			)}

			{/* Full Sleeve Content */}
			{activeTab === 'fullSleeve' && (
				<div className='artboard--main__variations--size-samples__tabs--content active'>
					{fullSleeveSizes.map((item, index) => (
						<div
							key={index}
							className='artboard--main__variations--size-samples__tabs--content--list'
               style={{cursor: "pointer"}}>
							<div className='size-age'>{item.age}</div>
							<div className='size-number'>{item.number}</div>
							<div className='size-measure' style={{ whiteSpace: 'nowrap' , display: "flex", alignItems: "center", justifyContent: "right" }}>
								{item.measure}
							</div>
						</div>
					))}
					<div className='block-center'>
						<Link to='/sizes' className='button-common button--light'>
							<img src='/assets/images/size-setting.svg' alt='' /> Change Sizes
						</Link>
					</div>
				</div>
			)}
		</div>
	);
}
